import React from 'react'

const Logs: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold text-gray-900">Nhật ký</h1>
      <p>Coming soon</p>
    </div>
  )
}

export default Logs 